import { render, staticRenderFns } from "./cambio_password.vue?vue&type=template&id=9ec9bbbe&scoped=true&"
import script from "./cambio_password.vue?vue&type=script&lang=js&"
export * from "./cambio_password.vue?vue&type=script&lang=js&"
import style0 from "./cambio_password.vue?vue&type=style&index=0&id=9ec9bbbe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ec9bbbe",
  null
  
)

export default component.exports